// used for edit/deletion
export const getAvailabilitiesAndResourcesIds = availabilities => {
  const itemsIds = [];
  for (const availability of availabilities) {
    itemsIds.push(availability.id);
    for (const resource of availability.resources) {
      itemsIds.push(resource.id);
    }
  }
  return itemsIds;
};

export const getUniqueSessionGroupIds = availabilities => {
  const allSessionGroupIds = [];
  for (const ava of availabilities) {
    if (!allSessionGroupIds.includes(ava.session_group_id)) {
      allSessionGroupIds.push(ava.session_group_id);
    }
  }
  return allSessionGroupIds;
};
